import PropTypes from 'prop-types';
import {
    Card,
    Table,
    Row,
    Col,
    Typography,
    Tag,
    Divider,
    Space,
    Statistic
} from 'antd';
import {
    CalendarOutlined,
    CarOutlined,
    SafetyOutlined,
    CalculatorOutlined,
    FileTextOutlined,
    PercentageOutlined
} from '@ant-design/icons';
import { frenchDate } from '../../../../variables/functions';
import { displayNumbers } from '../../../../variables/numbersFunctions';

const { Title, Text } = Typography;

const PreviewPrimes = (props) => {
    console.log(props?.preview);
    const guaranteesObligatoires = props?.preview?.compulsoryGuaranties?.filter(g => g.obligatoire);
    const guaranteesOptionnelles = props?.preview?.compulsoryGuaranties?.filter(g => !g.obligatoire);
    const isMultipleEngins = props?.preview?.engins && props?.preview?.engins?.length > 1;

    const obligatoiresColumns = [
        {
            title: 'Garantie',
            dataIndex: 'nom',
            key: 'nom',
            render: (text) => (
                <Space>
                    <Text strong>{text}</Text>
                    <Tag color="green">Obligatoire</Tag>
                </Space>
            ),
        },
        {
            title: 'Capital',
            dataIndex: 'capital',
            key: 'capital',
            align: 'right',
            render: (capital) => capital ? `${displayNumbers(capital)} F CFA` : '-',
        },
        {
            title: 'Prime Nette',
            dataIndex: 'primeNette',
            key: 'primeNette',
            align: 'right',
            render: (prime) => <Text strong style={{ color: '#1890ff' }}>{displayNumbers(prime)} F CFA</Text>,
        },
    ];

    const optionnellesColumns = [
        {
            title: 'Garantie',
            dataIndex: 'nom',
            key: 'nom',
            render: (text) => (
                <Space>
                    <Text strong>{text}</Text>
                    <Tag color="blue">Optionnelle</Tag>
                </Space>
            ),
        },
        {
            title: 'Capital',
            dataIndex: 'capital',
            key: 'capital',
            align: 'right',
            render: (capital) => capital ? `${displayNumbers(capital)} F CFA` : '-',
        },
        {
            title: 'Prime Nette',
            dataIndex: 'primeNette',
            key: 'primeNette',
            align: 'right',
            render: (prime) => <Text strong style={{ color: '#722ed1' }}>{displayNumbers(prime)} F CFA</Text>,
        },
    ];

    return (
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: 0, backgroundColor: '#f0f2f5', minHeight: 'auto' }}>
            <Card>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
                    color: 'white',
                    padding: 24,
                    marginBottom: 24,
                    borderRadius: 8
                }}>
                    <Space align="center" style={{ marginBottom: 6, marginTop: 0 }}>
                        <SafetyOutlined style={{ fontSize: 32 }} />
                        <Title level={2} style={{ color: 'white', margin: 0 }}>Aperçu des primes</Title>
                    </Space>
                    <br />
                    <Space size="large">
                        <Space>
                            <CalendarOutlined />
                            <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                                Date effet: {frenchDate(props?.preview?.dateEffet)}
                            </Text>
                        </Space>
                        <Space>
                            <CalendarOutlined />
                            <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
                                Date écheance:  {frenchDate(props?.preview?.dateEcheance)}
                            </Text>
                        </Space>
                    </Space>
                </div>

                {/* Section Véhicules */}
                {isMultipleEngins && (
                    <Card title={
                        <Space>
                            <CarOutlined style={{ color: '#1890ff' }} />
                            <span>Véhicules Assurés ({props?.preview?.engins.length})</span>
                        </Space>
                    } style={{ marginBottom: 24 }}>
                        <Row gutter={[16, 16]}>
                            {props?.preview?.engins.map((engin, index) => (
                                <Col span={24} key={index}>
                                    <Card size="small" style={{ backgroundColor: '#fafafa' }}>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={24} md={6}>
                                                <Text type="secondary">Marque & Puissance</Text>
                                                <br />
                                                <Text strong>{engin.marque} - {engin.puissance}</Text>
                                            </Col>
                                            <Col xs={24} md={6}>
                                                <Text type="secondary">N° Chassis</Text>
                                                <br />
                                                <Text strong>{engin.numeroChassis}</Text>
                                            </Col>
                                            <Col xs={24} md={6}>
                                                <Text type="secondary">Valeur Déclarée</Text>
                                                <br />
                                                <Text strong style={{ color: '#52c41a' }}>{displayNumbers(engin.valeurDeclaree)} F CFA</Text>
                                            </Col>
                                            <Col xs={24} md={6}>
                                                <Text type="secondary">Prime Nette</Text>
                                                <br />
                                                <Text strong style={{ color: '#1890ff' }}>{displayNumbers(engin.primeNette)} F CFA</Text>
                                            </Col>
                                        </Row>

                                        <Divider />
                                        <Text strong>Garanties:</Text>
                                        <div style={{ marginTop: 8 }}>
                                            {engin?.compulsoryGuaranties?.filter(cg => cg.primeNette > 0).map((garantie, gIndex) => (
                                                <Row key={gIndex} justify="space-between" style={{ marginBottom: 4 }}>
                                                    <Col>
                                                        <Space>
                                                            <Text>{garantie.nom}</Text>
                                                            <Tag color={garantie.obligatoire ? 'green' : 'blue'} size="small">
                                                                {garantie.obligatoire ? 'O' : 'Op'}
                                                            </Tag>
                                                        </Space>
                                                    </Col>
                                                    <Col>
                                                        {garantie.capital && (
                                                            <div style={{ textAlign: 'right', color: '#666' }}>
                                                                Capital: {displayNumbers(garantie.capital)}
                                                            </div>
                                                        )}
                                                        <Text strong>{displayNumbers(garantie.primeNette)} F CFA</Text>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Card>
                )}

                {/* Garanties Obligatoires */}
                {!isMultipleEngins && guaranteesObligatoires?.length > 0 && (
                    <Card
                        title={
                            <Space>
                                <SafetyOutlined style={{ color: '#52c41a' }} />
                                <span>Garanties Obligatoires</span>
                            </Space>
                        }
                        style={{ marginBottom: 24 }}
                    >
                        <Table
                            dataSource={guaranteesObligatoires?.filter(oc => oc?.primeNette > 0)}
                            columns={obligatoiresColumns}
                            pagination={false}
                            rowKey={(record, index) => index}
                        />
                    </Card>
                )}

                {/* Garanties Optionnelles */}
                {!isMultipleEngins && guaranteesOptionnelles?.length > 0 && (
                    <Card
                        title={
                            <Space>
                                <SafetyOutlined style={{ color: '#1890ff' }} />
                                <span>Garanties Optionnelles</span>
                            </Space>
                        }
                        style={{ marginBottom: 24 }}
                    >
                        <Table
                            dataSource={guaranteesOptionnelles?.filter(oc => oc?.primeNette > 0)}
                            columns={optionnellesColumns}
                            pagination={false}
                            rowKey={(record, index) => index}
                        />
                    </Card>
                )}
                {/* RC */}
                {(props?.preview?.rcDefaut !== props?.preview?.rcFinal) && (
                    <Card
                        title={
                            <Space>
                                <FileTextOutlined style={{ color: '#666' }} />
                                <span>Responsabilité Civile</span>
                            </Space>
                        }
                        style={{ backgroundColor: '#fafafa' }}
                    >
                        <Row gutter={[24, 16]}>
                            <Col xs={24} md={6}>
                                <Statistic
                                    title="RC par défaut"
                                    value={displayNumbers(props?.preview?.rcDefaut)}
                                    suffix="F CFA"
                                    valueStyle={{ color: '#666', fontSize: 14 }}
                                />
                            </Col>
                            {props?.preview?.bonusMalus !== 0 && (
                                <Col xs={24} sm={6}>
                                    <Statistic
                                        title="Bonus/Malus"
                                        value={displayNumbers(Math.abs(props?.preview?.bonusMalus))}
                                        suffix="F CFA"
                                        prefix={props?.preview?.bonusMalus > 0 ? '+' : '-'}
                                        valueStyle={{ color: props?.preview?.bonusMalus > 0 ? '#ff4d4f' : '#52c41a', fontSize: 14 }}
                                    />
                                </Col>
                            )}
                            {props?.preview?.flotte !== 0 && (
                                <Col xs={24} sm={6}>
                                    <Statistic
                                        title="Flotte"
                                        value={displayNumbers(Math.abs(props?.preview?.flotte))}
                                        suffix="%"
                                        prefix={'-'}
                                        valueStyle={{ color: '#ff4d4f', fontSize: 14 }}
                                    />
                                </Col>
                            )}
                            <Col xs={24} md={6}>
                                <Statistic
                                    title="RC finale"
                                    value={displayNumbers(props?.preview?.rcFinal)}
                                    suffix="F CFA"
                                    valueStyle={{ color: '#1890ff', fontSize: 14 }}
                                />
                            </Col>
                        </Row>
                    </Card>
                )}


                {/* Fractionnement */}
                {props?.preview?.primeNetteFractionnee > 0 && (
                    <Card
                        title={
                            <Space>
                                <PercentageOutlined style={{ color: '#fa8c16' }} />
                                <span>Fractionnement</span>
                            </Space>
                        }
                        style={{ marginBottom: 24, background: 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)' }}
                    >
                        <Row gutter={[24, 16]}>
                            <Col xs={24} md={12}>
                                <Statistic
                                    title="Taux de fractionnement"
                                    value={props?.preview?.fractionnement}
                                    suffix="%"
                                    valueStyle={{ color: '#fa8c16' }}
                                />
                            </Col>
                            <Col xs={24} md={12}>
                                <Statistic
                                    title="(Prime Nette + accessoires) Fractionnée"
                                    value={displayNumbers(props?.preview?.primeNetteFractionnee)}
                                    suffix="F CFA"
                                    valueStyle={{ color: '#52c41a' }}
                                />
                            </Col>
                        </Row>
                    </Card>
                )}


                {/* Détail des Primes */}
                <Card
                    title={
                        <Space>
                            <CalculatorOutlined style={{ color: '#722ed1' }} />
                            <span>Détail des Primes</span>
                        </Space>
                    }
                    style={{ marginBottom: 14, background: 'linear-gradient(135deg, #f9f0ff 0%, #fff0f6 100%)' }}
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={8}>
                            <Statistic
                                title="Prime Nette Annuelle"
                                value={displayNumbers(props?.preview?.primeNette)}
                                suffix="F CFA"
                                valueStyle={{ color: '#333', fontSize: 14 }}
                            />
                        </Col>
                        <Col xs={24} sm={8}>
                            <Statistic
                                title="Frais Accessoires"
                                value={displayNumbers(props?.preview?.accessoires)}
                                suffix="F CFA"
                                valueStyle={{ color: '#333', fontSize: 14 }}
                            />
                        </Col>
                        <Col xs={24} sm={8}>
                            <Statistic
                                title="Taxes à payer (6%)"
                                value={displayNumbers(props?.preview?.taxes)}
                                suffix="F CFA"
                                valueStyle={{ color: '#333', fontSize: 14 }}
                            />
                        </Col>

                    </Row>

                    <Divider />
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Title level={3} style={{ margin: 0, fontSize: 14 }}>Prime Totale à payer:</Title>
                        </Col>
                        <Col>
                            <Title level={2} style={{ color: '#722ed1', margin: 0, fontSize: 14 }}>
                                {displayNumbers(props?.preview?.primeTotale)} F CFA
                            </Title>
                        </Col>
                    </Row>
                </Card>


            </Card>
        </div>
    );
};

PreviewPrimes.propTypes = {
    preview: PropTypes.object
};

export default PreviewPrimes;